import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { RoleLevel, Unit, User } from '@/shared/types'

interface AuthState {
  user: User | null
  role: RoleLevel | null
  unit: Unit | null
  setSession: (user: User, role: RoleLevel, unit: Unit) => void
  switchRole: (role: RoleLevel, unit: Unit) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      role: null,
      unit: null,
      setSession: (user, role, unit) => set({ user, role, unit }),
      switchRole: (role, unit) => set({ role, unit }),
      logout: () => set({ user: null, role: null, unit: null }),
    }),
    {
      name: 'aits-auth',
    },
  ),
)
